import * as Yup from "yup";

export const LoginvalidationSchema = Yup.object().shape({
  // phoneNumber: Yup.string().required("Phone number is required"),
  IsEmail: Yup.string().required("Please enter a phone number or email"),
  // .email("Please enter a valid email address"),
  password: Yup.string().required("Password is required"),
});

export const SignUpvalidationSchema = Yup.object().shape({
  fullName: Yup.string().required("Full name is required"),
  // phoneNumber: Yup.string().required("Phone number is required"),
  IsEmail: Yup.string().required("Please enter a phone number or email"),
  // .email("Please enter a valid email address"),
  password: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Password must be at least 8 characters long, contain one uppercase letter, one lowercase letter, one digit, and one special character."
    ),
});
export const ForgotPasswordvalidation = Yup.object().shape({
  IsEmail: Yup.string()
    .required("Please enter a phone number or email")
    .email("Please enter a valid email address"),
});

export const ChangePasswordvalidation = Yup.object().shape({
  newPassword: Yup.string()
    .required("New Password is required")
    .min(8, "New Password must be at least 8 characters long.")
    .matches(
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Password must be at least 8 characters long, contain one uppercase letter, one lowercase letter, one digit, and one special character."
    ),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf(
      [Yup.ref("newPassword"), null],
      "New Password and Confirm Password must match."
    ),
});

export const BusinessCustomervalidation = Yup.object().shape({
  CompanyName: Yup.string()
    .required("Company name is required")
    .min(3, "Company name must be at least 3 characters")
    .max(50, "Company name must be at most 50 characters"),
  paymentFrequency: Yup.number().required("Payment frequency is required"),
});

export const EditProfilevalidation = Yup.object().shape({
  FullName: Yup.string()
    // .min(8, "Full name must be at least 2 characters long")
    // .max(50, "Full name can't exceed 50 characters")
    // .matches(/^[A-Za-z\s]+$/, "Full name can only contain letters and spaces")
    .required("Full Name is required"),
  // CompanyName: Yup.string().required("Company Name is required"),
  email: Yup.string().email("Invalid email address"),

  // phoneNumber: Yup.number().required("Phone number is required"),
  // PaymentFrequency: Yup.string().required("Payment Frequency is required"),
  // CustomerType: Yup.string().required("Customer Type is required"),
});

export const AchCardMainvalidation = Yup.object().shape({
  AccountName: Yup.string().required("Account name is required"),
  AccountNumber: Yup.number().required("Account number is required"),
  RoutingNumber: Yup.number().required("Routing number is required"),
});

export const CardFormvalidation = Yup.object().shape({
  CardNumber: Yup.string()
    .matches(/^\d{16}$/, "Must be a 16-digit number")
    .required("Enter your card number")
    .max(16, "Must be exactly 16 digits"),
  CardName: Yup.string().required("Enter Card Name your name"),
  ExpirationDate: Yup.string()
    .matches(
      /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/,
      "Must be in the format of MM/YY or MM/YYYY"
    )
    .required("Enter expiration date"),
  CVV: Yup.string()
    .matches(/^\d{3,4}$/, "Must be a 3 or 4-digit number")
    .required("Enter CVV"),
});

export const ProfilePasswordvalidation = Yup.object().shape({
  newPassword: Yup.string()
    .required("New Password is required")
    .min(8, "New Password must be at least 8 characters long.")
    .matches(
      /(?=.*?[A-Z])/,
      "New Password must contain at least one upper case."
    )
    .matches(
      /(?=.*?[a-z])/,
      "New Password must contain at least one lower case letter."
    )
    .matches(
      /(?=.*?[0-9!@#$%^&*])/,
      "New Password must contain at least one number or special character."
    ),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf(
      [Yup.ref("newPassword"), null],
      "New Password and Confirm Password must match."
    ),
});
